module.exports = __webpack_public_path__ + "static/media/background_login.71bb5b6f.jpg";